import { type DropdownItem } from '@/forms-legacy'
import { useMemo } from 'react'
import { timeUtils } from '@/server-data'
import { useSelector } from 'react-redux'
import { selectUserConfiguration } from '@/features/domain/user'

export function useOptions(date: uui.domain.YYYYMMDD) {
  const userConfig = useSelector(selectUserConfiguration)

  return useMemo<DropdownItem[]>(() => {
    return [
      {
        id: date,
        label: timeUtils.formatDate(userConfig)(date),
      },
    ]
  }, [userConfig, date])
}
